export default "__VITE_ASSET__DrP$mK7o__"